/* =====================================================
   SOIL2REMEDY THEME — JAVASCRIPT
   ===================================================== */

document.addEventListener('DOMContentLoaded', () => {

  /* ---- FAQ / Product Accordions ---- */
  document.querySelectorAll('.faq-item__btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const item   = btn.closest('.faq-item');
      const answer = item.querySelector('.faq-item__answer');
      const icon   = btn.querySelector('.faq-item__icon');
      const isOpen = answer.classList.contains('open');
      // close all in same list
      btn.closest('.faq-list').querySelectorAll('.faq-item__answer').forEach(a => a.classList.remove('open'));
      btn.closest('.faq-list').querySelectorAll('.faq-item__icon').forEach(i => i.textContent = '+');
      if (!isOpen) {
        answer.classList.add('open');
        icon.textContent = '−';
      }
    });
  });

  document.querySelectorAll('.product-accordion__btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const acc  = btn.closest('.product-accordion');
      const body = acc.querySelector('.product-accordion__body');
      const chev = btn.querySelector('.product-accordion__chevron');
      const isOpen = body.classList.contains('open');
      body.classList.toggle('open', !isOpen);
      if (chev) {
        const paths = chev.querySelector('path');
        if (paths) {
          if (isOpen) {
            paths.setAttribute('d', 'M12 5v14M5 12h14');
          } else {
            paths.setAttribute('d', 'M5 12h14');
          }
        }
      }
    });
  });

  /* ---- Quantity Stepper ---- */
  document.querySelectorAll('.product-qty').forEach(wrap => {
    const minus = wrap.querySelector('[data-action="minus"]');
    const plus  = wrap.querySelector('[data-action="plus"]');
    const val   = wrap.querySelector('.product-qty__val');
    if (!minus || !plus || !val) return;
    minus.addEventListener('click', () => {
      const current = parseInt(val.value, 10);
      if (isNaN(current) || current <= 1) {
        val.value = 1;
      } else {
        val.value = current - 1;
      }
    });
    plus.addEventListener('click', () => {
      const current = parseInt(val.value, 10);
      const next = (isNaN(current) ? 0 : current) + 1;
      const max = val.max ? parseInt(val.max, 10) : null;
      val.value = (max !== null && next > max) ? max : next;
    });
    val.addEventListener('input', () => {
      if (val.value === '' || isNaN(parseInt(val.value, 10))) {
        val.value = '';
        return;
      }
      let n = parseInt(val.value, 10);
      const max = val.max ? parseInt(val.max, 10) : null;
      if (n < 1) n = 1;
      if (max !== null && n > max) n = max;
      val.value = n;
    });
  });

  /* ---- Shared quantity reader (integer, clamped >= 1) ---- */
  function getQuantity(form) {
    const input = form.querySelector('.product-qty__val');
    let qty = parseInt(input ? input.value : '', 10);
    if (isNaN(qty) || qty < 1) qty = 1;
    const max = input && input.max ? parseInt(input.max, 10) : null;
    if (max !== null && qty > max) qty = max;
    return qty;
  }

  /* ---- Size Option Toggle ---- */
  document.querySelectorAll('.product-option__btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const wrap = btn.closest('.product-option__buttons');
      if (!wrap) return;
      wrap.querySelectorAll('.product-option__btn').forEach(b => {
        b.classList.remove('product-option__btn--selected');
        b.classList.add('product-option__btn--unselected');
      });
      btn.classList.add('product-option__btn--selected');
      btn.classList.remove('product-option__btn--unselected');
    });
  });

  /* ---- Cart count (Shopify AJAX) ---- */
  function setCartCount(count) {
    document.querySelectorAll('.site-header__cart-count').forEach(el => {
      el.textContent = count;
    });
  }
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => setCartCount(cart.item_count))
      .catch(() => {});
  }
  updateCartCount();

  /* ---- Cart drawer ---- */
  function formatMoney(cents) {
    const format = window.s2rMoneyFormat || '${{amount}}';
    const placeholders = {
      amount: [2, ',', '.'],
      amount_no_decimals: [0, ',', '.'],
      amount_with_comma_separator: [2, '.', ','],
      amount_no_decimals_with_comma_separator: [0, '.', ','],
      amount_with_apostrophe_separator: [2, "'", '.']
    };
    const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match || !placeholders[match[1]]) return format;
    const opts = placeholders[match[1]];
    let formatted = (cents / 100).toFixed(opts[0]).replace(/\B(?=(\d{3})+(?!\d))/g, opts[1]);
    if (opts[2] !== '.') formatted = formatted.replace('.', opts[2]);
    return format.replace(match[0], formatted);
  }

  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartDrawerBody = cartDrawer ? cartDrawer.querySelector('[data-cart-drawer-body]') : null;

  function renderCartDrawer(cart) {
    if (!cartDrawerBody) return;
    if (!cart.item_count) {
      cartDrawerBody.innerHTML =
        '<div class="cart-drawer__empty"><p>Your cart is empty.</p>' +
        '<a href="' + (window.Shopify && Shopify.routes ? Shopify.routes.all_products_collection_url : '/collections/all') + '" class="btn btn--primary">Shop products</a></div>';
      return;
    }
    const itemsHtml = cart.items.map(item => {
      const variantLabel = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="cart-drawer__item-variant">' + item.variant_title + '</p>'
        : '';
      const imageHtml = item.image
        ? '<img src="' + item.image + '" alt="' + item.product_title + '" loading="lazy" />'
        : '';
      return '<div class="cart-drawer__item">' +
        '<a class="cart-drawer__item-img" href="' + item.url + '">' + imageHtml + '</a>' +
        '<div class="cart-drawer__item-info">' +
          '<a class="cart-drawer__item-title" href="' + item.url + '">' + item.product_title + '</a>' +
          variantLabel +
          '<p class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</p>' +
          '<button type="button" class="cart-drawer__item-remove" data-remove-item="' + item.key + '">Remove</button>' +
        '</div>' +
        '<p class="cart-drawer__item-qty">Qty: ' + item.quantity + '</p>' +
      '</div>';
    }).join('');
    cartDrawerBody.innerHTML =
      '<div class="cart-drawer__items">' + itemsHtml + '</div>' +
      '<div class="cart-drawer__footer">' +
        '<div class="cart-drawer__subtotal"><span>Subtotal</span><strong>' + formatMoney(cart.total_price) + '</strong></div>' +
        '<a href="/checkout" class="btn btn--primary btn--full">Checkout</a>' +
        '<a href="/cart" class="btn btn--outline-dark btn--full">View cart</a>' +
      '</div>';
    cartDrawerBody.querySelectorAll('[data-remove-item]').forEach(btn => {
      btn.addEventListener('click', () => {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: btn.dataset.removeItem, quantity: 0 })
        })
          .then(r => r.json())
          .then(c => { renderCartDrawer(c); updateCartCount(); })
          .catch(() => {});
      });
    });
  }

  function openCartDrawer() {
    if (!cartDrawer) return;
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        renderCartDrawer(cart);
        setCartCount(cart.item_count);
        cartDrawer.classList.add('is-open');
        cartDrawer.setAttribute('aria-hidden', 'false');
        document.body.classList.add('no-scroll');
      })
      .catch(() => {});
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  }

  document.querySelectorAll('[data-cart-drawer-close]').forEach(el => {
    el.addEventListener('click', closeCartDrawer);
  });
  document.querySelectorAll('[data-cart-open]').forEach(el => {
    el.addEventListener('click', e => { e.preventDefault(); openCartDrawer(); });
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeCartDrawer();
  });

  /* ---- Add to cart (section product forms) ---- */
  function setAddLabel(btn, text) {
    const label = btn.querySelector('[data-add-label]');
    if (label) label.textContent = text;
    else btn.textContent = text;
  }
  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      if (btn.disabled) return;
      const form = btn.closest('form[data-product-form]');
      if (!form) return;
      const variantId = form.querySelector('[name="id"]')?.value;
      const qty = getQuantity(form);
      if (!variantId) return;
      btn.disabled = true;
      setAddLabel(btn, 'Adding…');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
        .then(r => {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(() => {
          updateCartCount();
          openCartDrawer();
          setAddLabel(btn, 'Added ✓');
          setTimeout(() => { setAddLabel(btn, btn.dataset.label || 'ADD TO CART'); btn.disabled = false; }, 1800);
        })
        .catch(err => {
          btn.disabled = false;
          setAddLabel(btn, 'SORRY, TRY AGAIN');
          setTimeout(() => { setAddLabel(btn, btn.dataset.label || 'ADD TO CART'); }, 2000);
        });
    });
  });

  /* ---- Buy It Now (replace cart with this item, then redirect to checkout) ---- */
  document.querySelectorAll('[data-buy-now]').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      if (btn.disabled) return;
      const form = btn.closest('form[data-product-form]');
      if (!form) return;
      const variantId = form.querySelector('[name="id"]')?.value;
      const qty = getQuantity(form);
      if (!variantId) return;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      // Clear the cart first so checkout totals exactly the selected quantity.
      fetch('/cart/clear.js', { method: 'POST' })
        .then(r => {
          if (!r.ok) throw new Error('clear failed');
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: qty })
          });
        })
        .then(r => {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(() => {
          window.location.href = '/checkout';
        })
        .catch(() => {
          btn.disabled = false;
          btn.textContent = 'BUY IT NOW';
        });
    });
  });

  /* ---- Reset stale state when returning to the page (back/forward) ---- */
  window.addEventListener('pageshow', () => {
    updateCartCount();
    closeCartDrawer();
  });
  window.addEventListener('pageshow', e => {
    if (!e.persisted) return;
    document.querySelectorAll('[data-buy-now]').forEach(btn => {
      btn.disabled = false;
      btn.textContent = 'BUY IT NOW';
    });
    document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
      btn.disabled = false;
      const label = btn.querySelector('[data-add-label]');
      if (label) label.textContent = btn.dataset.label || 'ADD TO CART';
    });
  });

  /* ---- Newsletter form ---- */
  document.querySelectorAll('[data-newsletter-form]').forEach(form => {
    form.addEventListener('submit', e => {
      e.preventDefault();
      const input = form.querySelector('input[type="email"]');
      const btn   = form.querySelector('button[type="submit"]');
      if (!input?.value) return;
      btn.textContent = 'Thank you! 🌿';
      btn.disabled = true;
      input.value = '';
      setTimeout(() => { btn.textContent = 'JOIN THE GARDEN'; btn.disabled = false; }, 3000);
    });
  });

  /* ---- Mobile menu toggle ---- */
  const menuBtn  = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', () => {
      const isOpen = mobileNav.style.display === 'block';
      mobileNav.style.display = isOpen ? 'none' : 'block';
    });
  }

  /* ---- Cart quantity controls ---- */
  document.querySelectorAll('[data-cart-qty]').forEach(qty => {
    const input = qty.querySelector('.cart-qty__input');
    const minus = qty.querySelector('[data-cart-qty-minus]');
    const plus = qty.querySelector('[data-cart-qty-plus]');
    if (!input || !minus || !plus) return;

    minus.addEventListener('click', () => {
      const current = parseInt(input.value || '0', 10);
      input.value = Math.max(0, current - 1);
    });

    plus.addEventListener('click', () => {
      const current = parseInt(input.value || '0', 10);
      input.value = current + 1;
    });
  });

});
